import { useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const PAGE_SIZE = 50;

export default function Admin() {
  // Token kept only in memory (state), never localStorage.
  const [tokenInput, setTokenInput] = useState("");
  const [token, setToken] = useState("");
  const [subscribers, setSubscribers] = useState([]);
  const [total, setTotal] = useState(0);
  const [skip, setSkip] = useState(0);
  const [error, setError] = useState("");
  const [loaded, setLoaded] = useState(false);

  const fetchPage = async (authToken, newSkip) => {
    setError("");
    try {
      const res = await fetch(
        `${API}/admin/subscribers?limit=${PAGE_SIZE}&skip=${newSkip}`,
        { headers: { Authorization: `Bearer ${authToken}` } }
      );
      if (res.status === 401 || res.status === 403) {
        setError("Invalid token.");
        setLoaded(false);
        return;
      }
      if (!res.ok) {
        setError("Failed to load subscribers.");
        return;
      }
      const data = await res.json();
      setSubscribers(data.subscribers || []);
      setTotal(data.total || 0);
      setSkip(newSkip);
      setToken(authToken);
      setLoaded(true);
    } catch (err) {
      setError("Failed to load subscribers.");
    }
  };

  const handleAuth = (e) => {
    e.preventDefault();
    if (!tokenInput.trim()) return;
    fetchPage(tokenInput.trim(), 0);
  };

  const downloadCsv = async () => {
    setError("");
    try {
      const res = await fetch(`${API}/admin/subscribers.csv`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) {
        setError("Failed to download CSV.");
        return;
      }
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "ticomi-subscribers.csv";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setError("Failed to download CSV.");
    }
  };

  const fmt = (iso) => {
    if (!iso) return "";
    try {
      return new Date(iso).toLocaleString();
    } catch {
      return iso;
    }
  };

  return (
    <div className="admin">
      <h1>{"TiCoMi \u2014 Subscribers"}</h1>

      {!loaded && (
        <form className="admin__auth" onSubmit={handleAuth}>
          <input
            type="password"
            placeholder="Paste admin token"
            value={tokenInput}
            onChange={(e) => setTokenInput(e.target.value)}
          />
          <button type="submit">View</button>
        </form>
      )}

      {error && <div className="admin__error">{error}</div>}

      {loaded && (
        <>
          <div className="admin__meta">
            <strong>{total} total signup{total === 1 ? "" : "s"}</strong>
            <button className="admin__csv" onClick={downloadCsv}>
              Download CSV
            </button>
          </div>

          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Email</th>
                <th>Signed up</th>
                <th>Source</th>
              </tr>
            </thead>
            <tbody>
              {subscribers.map((s, i) => (
                <tr key={s.email}>
                  <td>{skip + i + 1}</td>
                  <td>{s.email}</td>
                  <td>{fmt(s.created_at)}</td>
                  <td>{s.source}</td>
                </tr>
              ))}
              {subscribers.length === 0 && (
                <tr>
                  <td colSpan="4">No signups yet.</td>
                </tr>
              )}
            </tbody>
          </table>

          <div className="admin__pager">
            <button
              disabled={skip === 0}
              onClick={() => fetchPage(token, Math.max(0, skip - PAGE_SIZE))}
            >
              Previous
            </button>
            <span>
              {total === 0 ? 0 : skip + 1}
              {"\u2013"}
              {Math.min(skip + PAGE_SIZE, total)} of {total}
            </span>
            <button
              disabled={skip + PAGE_SIZE >= total}
              onClick={() => fetchPage(token, skip + PAGE_SIZE)}
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
}
